var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c(_vm.htmlTag,{tag:"component",class:[_vm.name],style:(_vm.cssVars)},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }